import type React from 'react';
import type { IntelligenceSectionTitle } from '.';

interface Props {
  title: IntelligenceSectionTitle;
  featureCount?: number;
  children?: React.ReactNode;
  subheader?: React.ReactNode;
  contentClassName?: string;
}

export default function IntelligenceSection({ children, subheader, contentClassName }: Props) {
  return (
    <div className="flex flex-col rounded">
      {subheader && <div className="my-2 flex w-full items-center justify-start space-x-2">{subheader}</div>}
      <div className={`mt-2 flex flex-col space-y-2 ${contentClassName}`}>{children}</div>
    </div>
  );
}
